<section class="main-wrap inner-views">
  <div class="container-wrap">
    <div class="sidebar-container sc-empty">
        <app-sidebar-empty></app-sidebar-empty>
    </div>
    <div class="content-container login-container form-container">
        <div class="row">
            <div class="col-md-12">
                <h1>Welcome to Eyelation</h1>
                <p class="subtitle">Address Information</p>
              <div class="form-wrap address-wrap">
                <app-address-info-form [isSignUp]="true"></app-address-info-form>
              </div>
            </div>
        </div>
    </div>
</div>
</section>
